import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import { Provider as StoreProvider } from 'react-redux';
import ReactDOM from 'react-dom';
import App from './App';
import { configureStore } from './store';
import { setupAxios } from './utils/axios';
import * as serviceWorker from './serviceWorker';
import { createBrowserHistory } from 'history';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';

const store = configureStore();
const history = createBrowserHistory();

setupAxios(store, history);

ReactDOM.render(
  <I18nextProvider i18n={i18n}>
    <StoreProvider store={store}>
      <App history={history} />
    </StoreProvider>
  </I18nextProvider>,
  document.getElementById('root')
);

serviceWorker.unregister();
